import axios from 'axios';

/**
 * Загрузка следующих элементов для отзывов во врачах и страницы видео отзывов.
 * @constructor
 */
export default function GalleryJS() {
  let isLoadingMore = false;
  let page = 2;

  const loadMoreBtn = document.querySelector('.loading-more-btn');
  const videoGrid = document.querySelector('.videos-grid');
  const doctorReviews = document.querySelector('.doctor-reviews__wrap');

  async function loadMoreRequest(route, contentElement, params) {
    const { data } = await axios.get(`/api/${route}`, params);

    if (data.data.pageData === null) {
      loadMoreBtn.innerHTML = '';
    } else {
      contentElement.insertAdjacentHTML('beforeend', data.data.pageData);

      if (data.data.isLastPage) {
        loadMoreBtn.innerHTML = '';
        loadMoreBtn.setAttribute('style', 'display: none;');
      }
    }

    page += 1;
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async function loadMore() {
      if (isLoadingMore) return;
      isLoadingMore = true;

      try {
        switch (true) {
          case this.classList.contains('video-btn'): {
            await loadMoreRequest('get-more-video/', videoGrid, {
              params: {
                page,
                city: takeUrlGetParams('city'),
                doctor: takeUrlGetParams('doctor'),
                category: takeUrlGetParams('category'),
              },
            });
            break;
          }
          case this.classList.contains('doctor-review-btn'): {
            const id = doctorReviews.dataset.doctorid;
            await loadMoreRequest(`get-more-reviews/${id}`, doctorReviews, {
              params: { page },
            });
            break;
          }
          //
          default: break;
        }
      } finally {
        isLoadingMore = false;
      }
    });
  }
}

/**
 * Получить значение GET параметра.
 * @param parameter GET параметр.
 * @returns {string}
 */
function takeUrlGetParams(parameter) {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  return searchParams.get(parameter);
}
